import script from "./invite-user-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./invite-user-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__